import reduceReducers from "reduce-reducers";

import { BILLING_SETTINGS } from "constants/actionTypes";

import {
  apiModelOfflineFetchReducer,
  apiModelOfflineUpdateReducer,
} from "lib/reducers";
import { deserializeBillingSettings } from "lib/serializers/billingSettings";

const fetch = apiModelOfflineFetchReducer(BILLING_SETTINGS, {
  deserializer: deserializeBillingSettings,
  clearOnRequest: true,
});

/* 
Note - update is not currently used in the app - these are pushed up through the deployment endpoint, and pull down standalone. 
 */
const update = apiModelOfflineUpdateReducer(BILLING_SETTINGS, {
  deserializer: deserializeBillingSettings,
});

const billingSettingsReducer = reduceReducers(fetch, update);

export default billingSettingsReducer;
